module.exports = __webpack_public_path__ + "img/qrcode_2.1bca2d2.png";